(function () {
  'use strict';

  function slideStep(track) {
    var slide = track.querySelector('.product-shelf__slide');
    if (!slide) return track.clientWidth * 0.8;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return slide.getBoundingClientRect().width + gap;
  }

  function updateNav(viewport) {
    var track = viewport.querySelector('[data-shelf-track]');
    var prev = viewport.querySelector('[data-shelf-prev]');
    var next = viewport.querySelector('[data-shelf-next]');
    if (!track) return;

    var max = Math.max(0, track.scrollWidth - track.clientWidth);
    var x = track.scrollLeft;
    var atStart = x <= 2;
    var atEnd = x >= max - 2;

    if (prev) {
      prev.disabled = atStart;
      prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
    }
    if (next) {
      next.disabled = atEnd || max <= 2;
      next.setAttribute('aria-disabled', atEnd || max <= 2 ? 'true' : 'false');
    }
  }

  function bindViewport(viewport) {
    if (viewport.dataset.shelfBound === '1') {
      updateNav(viewport);
      return;
    }
    viewport.dataset.shelfBound = '1';

    var track = viewport.querySelector('[data-shelf-track]');
    var prev = viewport.querySelector('[data-shelf-prev]');
    var next = viewport.querySelector('[data-shelf-next]');
    if (!track) return;

    function go(dir) {
      track.scrollBy({ left: dir * slideStep(track), behavior: 'smooth' });
    }

    if (prev) {
      prev.addEventListener('click', function () {
        go(-1);
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        go(1);
      });
    }

    track.addEventListener(
      'scroll',
      function () {
        updateNav(viewport);
      },
      { passive: true }
    );

    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') {
        e.preventDefault();
        go(1);
      } else if (e.key === 'ArrowLeft') {
        e.preventDefault();
        go(-1);
      }
    });

    updateNav(viewport);
  }

  function activateGrid(shelf, indexOrId) {
    var viewports = shelf.querySelectorAll('[data-shelf-viewport]');
    viewports.forEach(function (viewport, gridIndex) {
      var isTarget =
        typeof indexOrId === 'number'
          ? gridIndex === indexOrId
          : viewport.id === indexOrId;
      viewport.classList.toggle('is-active', isTarget);
      viewport.setAttribute('aria-hidden', isTarget ? 'false' : 'true');
      if (isTarget) {
        var track = viewport.querySelector('[data-shelf-track]');
        if (track) track.scrollLeft = 0;
        requestAnimationFrame(function () {
          updateNav(viewport);
        });
      }
    });
  }

  function initShelf(shelf) {
    if (shelf.dataset.fadeInit !== '1') {
      shelf.dataset.fadeInit = '1';

      var fadeTargets = shelf.querySelectorAll('.fade-up');

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        fadeTargets.forEach(function (el) {
          el.classList.add('visible');
        });
      } else {
        var fadeObserver = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('visible');
              } else {
                entry.target.classList.remove('visible');
              }
            });
          },
          { rootMargin: '0px 0px -10% 0px', threshold: 0.01 }
        );
        fadeTargets.forEach(function (el) {
          fadeObserver.observe(el);
        });
      }
    }

    shelf.querySelectorAll('[data-shelf-viewport]').forEach(bindViewport);

    window.addEventListener(
      'resize',
      function () {
        var active = shelf.querySelector('[data-shelf-viewport].is-active');
        if (active) updateNav(active);
      },
      { passive: true }
    );

    var tabsContainer = shelf.querySelector('.product-shelf__tabs');
    var hshTabs = shelf.querySelectorAll('.hsh-filters [data-hsh-tab]');

    if (!tabsContainer && !hshTabs.length) return;

    if (!tabsContainer && hshTabs.length) {
      var hshTabArr = Array.from(hshTabs);

      function setActiveHshTab(activeIndex) {
        hshTabArr.forEach(function (tab, tabIndex) {
          var isActive = tabIndex === activeIndex;
          tab.classList.toggle('hsh-tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
      }

      var firstActiveHsh = hshTabArr.find(function (tab) {
        return tab.classList.contains('hsh-tab--active');
      });
      var initialHshIndex = Math.max(hshTabArr.indexOf(firstActiveHsh || hshTabArr[0]), 0);
      setActiveHshTab(initialHshIndex);
      activateGrid(shelf, initialHshIndex);

      hshTabArr.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          setActiveHshTab(index);
          activateGrid(shelf, index);
        });
      });

      return;
    }

    var tabs = tabsContainer.querySelectorAll('.product-shelf__tab');
    var slider = tabsContainer.querySelector('.product-shelf__tabs-slider');

    function moveSlider(btn) {
      if (!slider || !btn) return;
      slider.style.left = btn.offsetLeft + 'px';
      slider.style.width = btn.offsetWidth + 'px';
    }

    if (tabsContainer.dataset.shelfTabsBound === '1') {
      moveSlider(tabsContainer.querySelector('.product-shelf__tab.is-active'));
      return;
    }
    tabsContainer.dataset.shelfTabsBound = '1';

    var firstActive = tabsContainer.querySelector('.product-shelf__tab.is-active');
    if (firstActive && slider) {
      slider.style.transition = 'none';
      moveSlider(firstActive);
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          slider.style.transition = '';
        });
      });
    }

    window.addEventListener(
      'resize',
      function () {
        var active = tabsContainer.querySelector('.product-shelf__tab.is-active');
        if (active) moveSlider(active);
      },
      { passive: true }
    );

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        moveSlider(tab);
        activateGrid(shelf, tab.getAttribute('data-target'));
      });
    });

    tabsContainer.addEventListener('keydown', function (e) {
      var active = tabsContainer.querySelector('.product-shelf__tab.is-active');
      var tabArr = Array.from(tabs);
      var idx = tabArr.indexOf(active);

      if (e.key === 'ArrowRight') {
        e.preventDefault();
        var next = tabArr[(idx + 1) % tabArr.length];
        next.click();
        next.focus();
      }

      if (e.key === 'ArrowLeft') {
        e.preventDefault();
        var prev = tabArr[(idx - 1 + tabArr.length) % tabArr.length];
        prev.click();
        prev.focus();
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.product-shelf').forEach(initShelf);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var shelf = e.target.querySelector('.product-shelf');
    if (shelf) {
      delete shelf.dataset.fadeInit;
    shelf.querySelectorAll('[data-shelf-viewport]').forEach(function (viewport) {
      delete viewport.dataset.shelfBound;
    });
    var tabsEl = shelf.querySelector('.product-shelf__tabs');
    if (tabsEl) delete tabsEl.dataset.shelfTabsBound;
    initShelf(shelf);
    }
  });
})();
